export enum Referer {
  MyLP = 'MyLeasePlan',
  SalesForce = 'SalesForce',
  SalesPortal = 'SalesPortal',
  MyAY = 'MyAyvens',
  MyNordea = 'MyNordea',
  FleetManager = 'FleetManager',
}
